import Image from "next/image";

interface ResponsivePictureProps {
  baseSrc: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  fill?: boolean;
}

const ResponsivePicture = ({
  baseSrc,
  alt,
  className,
  width,
  height,
  fill = false,
}: ResponsivePictureProps) => {
  return (
    <picture>
      <source srcSet={`${baseSrc}.webp`} type="image/webp" />
      <source srcSet={`${baseSrc}.png`} type="image/png" />
      <Image
        src={`${baseSrc}.webp`}
        alt={alt}
        {...(fill
          ? { fill: true }
          : {
              width: width ?? 500,
              height: height ?? 500,
            })}
        className={className}
        loading="lazy"
      />
    </picture>
  );
};

export default ResponsivePicture;
